/** @file The form field an error path points at: the deepest field whose path prefixes it. */
import type { FieldSpec } from './schemaFields';

/** Path key of that field (`a` for `a.1`), or null when the path is empty or matches no field. */
export function fieldAtPath(fields: readonly FieldSpec[], path: string | undefined): string | null {
  if (path === undefined || path === '') return null;
  let best: string | null = null;
  const visit = (list: readonly FieldSpec[]): void => {
    for (const field of list) {
      const key = field.path.join('.');
      if (path === key || path.startsWith(`${key}.`)) best = key;
      if (field.kind === 'group') visit(field.fields);
    }
  };
  visit(fields);
  return best;
}
